// Extracted from templates/page.clinical-monograph.liquid (CLAUDE.md rule 8:
// no inline <script> blocks). Loaded with defer, so the DOM is ready.

(function(){
  var bar=document.getElementById('protoBar'),by=document.querySelector('.byline'),card=document.querySelector('.pr-cta-final');
  if(!bar||!by)return;
  
  var rs=document.querySelector('.reset');
  if(rs&&'IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){bar.classList.toggle('alt',e.isIntersecting);});},{threshold:0.05}).observe(rs);}
  var pastByline=false,cardVisible=false,dirUp=false,lastY=window.scrollY;
  function upd(){
    var full=pastByline&&!cardVisible&&!dirUp, peek=pastByline&&!cardVisible&&dirUp;
    bar.classList.toggle('show',full);bar.classList.toggle('peek',peek);
    document.body.classList.toggle('has-bar',full);
  }
  window.addEventListener('scroll',function(){var y=window.scrollY;if(Math.abs(y-lastY)>4){dirUp=y<lastY;lastY=y;upd();}},{passive:true});
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(e){pastByline=e.boundingClientRect.bottom<0&&!e.isIntersecting;upd();});},{threshold:0}).observe(by);
    if(card)new IntersectionObserver(function(es){es.forEach(function(e){cardVisible=e.isIntersecting;upd();});},{threshold:.15}).observe(card);
  }else{window.addEventListener('scroll',function(){pastByline=window.scrollY>600;upd();});}
})();

(function(){
  var figs=document.querySelectorAll('figure.anim');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('inview',e.isIntersecting);});},{threshold:.25});
    figs.forEach(function(f){io.observe(f);});
  }else{figs.forEach(function(f){f.classList.add('inview');});}
    if(sel){sel.addEventListener('change',function(){var v=sel.value;document.querySelectorAll('.matrix .cmp').forEach(function(c){c.classList.toggle('on',c.classList.contains('c'+v));});});}
  // page navigation: mark current section
  var items=document.querySelectorAll('.pn li');
  var targets=[];items.forEach(function(li){var t=document.querySelector(li.querySelector('a').getAttribute('href'));if(t)targets.push([t,li]);});
  if('IntersectionObserver' in window&&targets.length){
    var cur=null;
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){items.forEach(function(l){l.classList.remove('cur')});var m=targets.find(function(p){return p[0]===e.target});if(m)m[1].classList.add('cur');}});},{rootMargin:'-10% 0px -80% 0px'});
    targets.forEach(function(p){io2.observe(p[0]);});
  }
})();
